import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Form, Modal } from "react-bootstrap";
import moment from "moment";
import { truncate } from "lodash";
import currencyRupees from "./../../../images/currencyRupees.svg";
import axios from "axios";
import { API_URL } from "../../../config";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as yup from "yup";
import { CampusDriveStatus, getSalaryLPA } from "../../../utils/helper";

const validationSchema = yup.object().shape({
  selectedJobStatus: yup
    .string()
    .required("Status is required")
    .oneOf(
      ["live", "hold", "cancelled", "draft", "closed"],
      "Invalid status value",
    ),
  remark: yup.string().required("Remark is required"),
});

const CampusDriveCard = ({ drive, handleReport }) => {
  const status = drive.drive_status;
  const [modalShow, setModalShow] = useState(false);
  const [selectedJobStatus, setSelectedJobStatus] = useState("");
  const [remark, setRemark] = useState("");
  const collegeId = useSelector((state) => state.college_id.college_id);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const resetForm = () => {
    setSelectedJobStatus("");
    setRemark("");
    setValidationErrors({});
  };

  const selectOptionStatus = (() => {
    if (status === CampusDriveStatus.LIVE) {
      return [
        {
          name: "Hold",
          value: CampusDriveStatus.HOLD,
        },
        {
          name: "Cancelled",
          value: CampusDriveStatus.CANCELLED,
        },
        {
          name: "Closed",
          value: CampusDriveStatus.CLOSED,
        },
      ];
    }
    if (status === CampusDriveStatus.HOLD) {
      return [
        {
          name: "Cancelled",
          value: CampusDriveStatus.CANCELLED,
        },
        {
          name: "Closed",
          value: CampusDriveStatus.CLOSED,
        },
      ];
    }
    if (status === CampusDriveStatus.CANCELLED) {
      return [];
    }
    if (status === CampusDriveStatus.CLOSED) {
      return [];
    }
    if (status === CampusDriveStatus.DRAFT) {
      return [
        {
          name: "Live",
          value: CampusDriveStatus.LIVE,
        },
        {
          name: "Hold",
          value: CampusDriveStatus.HOLD,
        },
        {
          name: "Cancelled",
          value: CampusDriveStatus.CANCELLED,
        },
        {
          name: "Closed",
          value: CampusDriveStatus.CLOSED,
        },
      ];
    }
    return [];
  })();

  const changeStatus = async () => {
    try {
      setLoading(true);
      setValidationErrors({});

      // Validate form
      await validationSchema.validate(
        { selectedJobStatus, remark },
        { abortEarly: false },
      );

      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const authToken = userDetails?.data?.auth_token;

      const formData = new FormData();
      formData.append("campus_drive_id", drive.campus_drive_id);
      formData.append("drive_status", selectedJobStatus);
      formData.append("remark", remark);
      formData.append("college_id", collegeId);

      const response = await axios.post(
        `${API_URL}/api/freshment_portal_apis/CampusDrive/change_job_status`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      if (response.data.success) {
        toast.success(response.data.message || "Status changed successfully", {
          autoClose: true,
          closeButton: true,
          hideProgressBar: false,
        });
        resetForm();
        setModalShow(false);
      } else {
        throw new Error(response.data.message || "Failed to change status");
      }
    } catch (error) {
      if (error.inner) {
        console.log(error.inner);
        const errors = {};
        error.inner.forEach((err) => {
          errors[err.path] = err.message;
        });
        setValidationErrors(errors);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="col-xl-6 col-xxl-6 col-md-12 col-sm-12">
        <div className="card">
          <div className="jobs2 card-body text-start">
            <div>
              <div className="d-flex justify-content-between">
                <div className="d-flex text-start align-items-center mb-3">
                  <div style={{ height: 50, width: 50 }} className="me-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="100%"
                      viewBox="0 0 48 48"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <rect width="48" height="48" fill="none" />
                      <g
                        fill="none"
                        stroke="#005dba"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="4"
                      >
                        <path d="M11 14L25 4v40H11z" clipRule="evenodd" />
                        <path d="m25 13l14 10v21M4 44h40" />
                      </g>
                    </svg>
                  </div>
                  <div className="d-block text-start">
                    <h5 className="fs-20 mb-2" style={{ fontWeight: 400 }}>
                      {drive.company_name
                        ? truncate(drive.company_name, 75)
                        : "N/A"}
                    </h5>
                    <div className="d-flex align-items-center mb-2">
                      <i className="fas fa-briefcase me-2 text-primary"></i>
                      <span>
                        {drive?.job_role_name ||
                          drive?.other_job_role_name ||
                          "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  <Button
                    as={Link}
                    to={`/campus-drive-details/${drive.campus_drive_id}`}
                    variant="primary"
                    size="sm"
                  >
                    View Drive
                  </Button>
                </div>
              </div>
              <div>
                <span className="mb-3 d-block">
                  Job Type :{" "}
                  <span style={{ fontWeight: 500 }}>
                    {drive.job_type
                      ? drive.job_type.toLowerCase() === "part-time"
                        ? "Part Time"
                        : drive.job_type.toLowerCase() === "full-time"
                          ? "Full Time"
                          : drive.job_type.charAt(0).toUpperCase() +
                            drive.job_type.slice(1)
                      : "Full Time"}
                  </span>
                </span>
                <span className="mb-3 d-block">
                  Contact :{" "}
                  <span style={{ fontWeight: 500 }}>
                    {drive.hr_contact_number || "N/A"}
                  </span>
                </span>
                <span className="mb-3 d-block">
                  Location :{" "}
                  <span style={{ fontWeight: 500 }}>
                    {drive.job_location || "N/A"}
                  </span>
                </span>
                <span className="mb-3 d-block">
                  Total Openings :{" "}
                  <span style={{ fontWeight: 500 }}>
                    {drive.total_vacancy || "N/A"}
                  </span>
                </span>
              </div>
              <div
                className="d-flex mb-3 flex-wrap mt-2 justify-content-between"
                style={{ alignItems: "center" }}
              >
                <div className="d-flex flex-wrap gap-2">
                  {(() => {
                    const statusLabel = (() => {
                      switch (status) {
                        case "live":
                          return "Live";
                        case "hold":
                          return "Hold";
                        case "cancelled":
                          return "Cancelled";
                        case "draft":
                          return "Draft";
                        case "closed":
                          return "Closed";
                        default:
                          return "N/A";
                      }
                    })();

                    return (
                      <span
                        className="badge rounded-pill fs-12"
                        style={{
                          backgroundColor: "#f2f2f2",
                          color: "#4b5563",
                          border: "1px solid #d1d5db",
                          padding: "8px 15px",
                          fontWeight: "500",
                        }}
                      >
                        {statusLabel}
                      </span>
                    );
                  })()}
                </div>
                <div>
                  <span className="font-weight-bold d-block">
                    Posted: {moment(drive.created_at).format("DD-MM-YYYY")}
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className="col-12"
                style={{
                  width: "100%",
                  backgroundColor: "#cccccc",
                  height: "1px",
                }}
              ></div>
            </div>
            <div
              className="d-flex mb-1 mt-4 justify-content-between"
              style={{ gap: 10 }}
            >
              <div className="d-flex" style={{ gap: 10, alignItems: "center" }}>
                <span
                  className="d-flex align-items-center"
                  style={{ gap: 5, fontSize: 16 }}
                >
                  <img
                    loading="lazy"
                    src={currencyRupees}
                    alt="Logo"
                    className="mt-[-6px] w-[30px] h-[30px] sm:w-[26px] sm:h-[26px] "
                  />
                  {drive.job_type === "internship"
                    ? drive.salary
                    : getSalaryLPA(drive.salary) + " LPA"}
                  <span className="text-muted fs-12">
                    ({drive.job_type === "internship" ? "Stipend" : "Salary"})
                  </span>
                </span>
              </div>
              <div className="d-flex" style={{ gap: 5 }}>
                {status !== CampusDriveStatus.CANCELLED && (
                  <Button
                    onClick={() => setModalShow(true)}
                    size="sm"
                    variant="warning"
                  >
                    Change Status
                  </Button>
                )}
                {!(
                  status === CampusDriveStatus.CANCELLED ||
                  status === CampusDriveStatus.CLOSED
                ) && (
                  <Button
                    as={Link}
                    to={`/campus-drive-edit/${drive.campus_drive_id}`}
                    size="sm"
                    variant="danger"
                  >
                    Edit Drive
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={modalShow}
        onHide={() => {
          resetForm();
          setModalShow(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Change Status
          </Modal.Title>
          <Button
            onClick={() => {
              resetForm();
              setModalShow(false);
            }}
            variant=""
            className="btn-close"
          ></Button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="mb-3">
            <select
              className={`form-control ${
                validationErrors.selectedJobStatus ? "is-invalid" : ""
              }`}
              value={selectedJobStatus}
              placeholder="Select Status"
              name="selectedJobStatus"
              onChange={(e) => {
                setSelectedJobStatus(e.target.value);
                setValidationErrors((prev) => ({
                  ...prev,
                  selectedJobStatus: undefined,
                }));
              }}
            >
              <option value="">Select Status</option>
              {selectOptionStatus?.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.name}
                </option>
              ))}
            </select>
            {validationErrors.selectedJobStatus && (
              <div className="invalid-feedback">
                {validationErrors.selectedJobStatus}
              </div>
            )}
          </div>

          <Form.Control
            as="textarea"
            rows={3}
            value={remark}
            name="remark"
            onChange={(e) => {
              setRemark(e.target.value);
              setValidationErrors((prev) => ({ ...prev, remark: undefined }));
            }}
            className={validationErrors.remark ? "is-invalid" : ""}
            placeholder="Write here..."
            style={{ height: "100px", border: "1px solid #cccccc" }}
          />
          {validationErrors.remark && (
            <div className="invalid-feedback d-block">
              {validationErrors.remark}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              resetForm();
              setModalShow(false);
            }}
            variant=""
            className="btn-danger"
          >
            Close
          </Button>
          <Button variant="" className="btn-success" onClick={changeStatus} disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Changing Status...
              </>
            ) : (
              "Change Status"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CampusDriveCard;
